import React from "react";

import formatCurrency from "../../Component/EmployeeComponents/formatCurrency";

import BadgeTable from "./BadgeTable";
import PackageTable from "./PackageTable";
import CreateBadge from "./BadgeForm";
import CreatePackage from "./CreatePackage";
import KpiCard from "../../Component/EmployeeComponents/KpiCard";
import BadgeForm from "./BadgeForm";

const initialLeads = [
  {
    id: 1,
    name: "Acme Corp Website Revamp",
    owner: "John Doe",
    status: "New",
    location:"vashi",
    value: 12000,
    createdAt: "2025-01-15",
  },
  {
    id: 2,
    name: "Globex Cloud Migration",
    owner: "Sarah Lee",
    status: "In Progress",
    location:"Chembur",
    value: 45000,
    createdAt: "2025-02-10",
  },
  {
    id: 3,
    name: "Initech Support Contract",
    owner: "Michael Scott",
    status: "Won",
    location:"vashi",
    value: 30000,
    createdAt: "2025-02-25",
  },
  {
    id: 4,
    name: "Umbrella Security Audit",
    owner: "Angela Martin",
    status: "Lost",
    location:"KoparKhairane",
    value: 18000,
    createdAt: "2025-03-05",
  },
  {
    id: 5,
    name: "Stark Industries License",
    owner: "Tony Stark",
    status: "Won",
    location:"vashi",
    value: 80000,
    createdAt: "2025-03-22",
  },
  {
    id: 6,
    name: "Wayne Enterprises CRM",
    owner: "Bruce Wayne",
    status: "In Progress",
    location:"Ghansoli",
    value: 52000,
    createdAt: "2025-04-02",
  },
  {
    id: 7,
    name: "Hooli Cloud Expansion",
    owner: "Pied Piper",
    status: "New",
    location:"Rabale",
    value: 26000,
    createdAt: "2025-04-18",
  },
  {
    id: 8,
    name: "Aperture Science SLA",
    owner: "Chell",
    status: "Won",
    location:"Thane",
    value: 15000,
    createdAt: "2025-05-03",
  },
];

export default function BadgePackageDashboard() {
  const [leads, setLeads] = React.useState(initialLeads);
  console.log("leads data", leads)
  const [filterStatus, setFilterStatus] = React.useState("All");

  const filteredLeads = React.useMemo(() => {
    if (filterStatus === "All") return leads;
    return leads.filter((l) => l.status === filterStatus);
  }, [leads, filterStatus]);

  const metrics = React.useMemo(() => {
    const totalLeads = leads.length;
    const wonLeads = leads.filter((l) => l.status === "Won");
    const lostLeads = leads.filter((l) => l.status === "Lost");
    const inProgressLeads = leads.filter((l) => l.status === "In Progress");
    const newLeads = leads.filter((l) => l.status === "New");

    const revenue = wonLeads.reduce((sum, l) => sum + l.value, 0);
    const pipeline = inProgressLeads.reduce((sum, l) => sum + l.value, 0);
    const conversionRate =
      totalLeads === 0 ? 0 : Math.round((wonLeads.length / totalLeads) * 100);

    const monthlyTarget = 200000;

    return {
      totalLeads,
      newLeads: newLeads.length,
      inProgressLeads: inProgressLeads.length,
      wonLeads: wonLeads.length,
      lostLeads: lostLeads.length,
      revenue,
      pipeline,
      conversionRate,
      monthlyTarget,
    };
  }, [leads]);

  const handleCreateLead = (lead) => {
    setLeads((prev) => [lead, ...prev]);
  };

  return (
    <div className="min-h-screen flex flex-col">
      {/* <header className="bg-white border-b border-slate-200">
        <div className=" mx-auto px-4 py-3 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-xl bg-blue-600 flex items-center justify-center text-white font-bold">
              EX
            </div>
            <div>
              <div className="text-sm md:text-base font-semibold text-slate-900">
                Executive Leads Dashboard
              </div>
              <div className="text-[11px] text-slate-500">
                Blue &amp; white executive view of leads, KPIs, reports &amp; team
              </div>
            </div>
          </div>
        </div>
      </header> */}

      <main className="flex-1">
        <div className=" mx-auto px-2 py-4 md:py-6 space-y-4 md:space-y-6">
          {/* KPIs */}
          {/* <section className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
            <KpiCard
              label="Total Leads"
              value={metrics.totalLeads}
              sublabel={`${metrics.newLeads} new this period`}
              filter="All"
              leads={leads}                    // FULL LIST
            />

            <KpiCard
              label="Won Deals"
              value={metrics.wonLeads}
              sublabel={formatCurrency(metrics.revenue) + " Won"}
              filter="Won"
              leads={leads}                    // FULL LIST
            />

            <KpiCard
              label="Pipeline Value"
              value={formatCurrency(metrics.pipeline)}
              sublabel={`${metrics.inProgressLeads} in progress`}
              filter="In Progress"
              leads={leads}                    // FULL LIST
            />

            <KpiCard
              label="Conversion Rate"
              value={metrics.conversionRate + "%"}
              sublabel={`${metrics.lostLeads} lost deals`}
              filter="Lost"
              leads={leads}                    // FULL LIST
            />
          </section> */}



          {/* Leads + Create + Target */}
          <section className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
            <div className="lg:col-span-2 flex flex-col gap-4">
              <BadgeTable
                leads={filteredLeads}
                filterStatus={filterStatus}
                setFilterStatus={setFilterStatus}
              />

              <PackageTable
                leads={filteredLeads}
                filterStatus={filterStatus}
                setFilterStatus={setFilterStatus}
              />

              {/* <ReportsTable leads={leads} /> */}
            </div>
            <div className="hidden md:flex flex-col gap-4">
              <BadgeForm onCreate={handleCreateLead} />
              <CreatePackage onCreate={handleCreateLead} />
              {/* <div className="flex flex-row gap-4">
                <TargetCard
                target={metrics.monthlyTarget}
                achieved={metrics.revenue}
              />

              <IncentiveCard
                targetIncentive={50000} 
                achievedIncentive={32000} 
              />
              </div> */}
            </div>
          </section>

          {/* Charts row (modern design) */}
          {/* <section className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            <MonthlyWonChart leads={leads} />
            <LeadsByStatusBar leads={leads} />
          </section> */}

          {/* Reports table */}
          

          {/* Team members section */}
          {/* <TeamMembersSection leads={leads} /> */}
        </div>
      </main>
    </div>
  );
}